<template>
  <div class="flex col-gap-4 pl-4">
    <IconCheckSquare
        class="transition duration-200 cursor-pointer text-icon hover:text-icon-hover overflow-visible"
        @click.native="$emit('confirm')"/>
    <IconEdit
        class="transition duration-200 cursor-pointer text-icon hover:text-icon-hover overflow-visible"
        @click.native="$emit('edit')"/>
  </div>
</template>

<script>
import IconEdit from "@/components/icons/IconEdit";
import IconCheckSquare from "@/components/icons/IconCheckSquare";

export default {
  name: "PlannedActions",
  components: {IconCheckSquare, IconEdit}
}
</script>